import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const examCategoryService = {
    getAll,
    getAllExamCategories,
    addExamCategory,
    updateExamCategory,
    deleteExamCategory,
};

async function getAll(limit, offset, search_term, sort_column, sort_direction) {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    
    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/exam-categories/getAllExamCategories/?limit=${limit}&offset=${offset}&search_term=${search_term}&sort_column=${sort_column}&sort_direction=${sort_direction}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllExamCategories() {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/exam-categories/getAll/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function addExamCategory(newExamCategory) {
    const configOptions = {
        method: "POST",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(newExamCategory),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/exam-categories/add/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function updateExamCategory(examCategoryItem, examCategoryId) {
    const configOptions = {
        method: "PUT",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(examCategoryItem),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/exam-categories/update/${examCategoryId}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function deleteExamCategory(id) {
    const configOptions = {
        method: "DELETE",
        headers: {
        ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/exam-categories/delete/${id}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}
